module.exports = __webpack_public_path__ + "img/background.f16e6bf5.png";